import styled from 'styled-components';

export const FieldArrayButton = styled.div`
  display: flex;
  width: 24px;
  height: 24px;
  padding: 2px;
  align-items: center;
  gap: 10px;
  justify-content: center;
  cursor: pointer;
`;
